//角色
export const roleUrl = '/identity/roles'
export const getAllRole = () => `${roleUrl}/all`
export const getRolePage = () => `${roleUrl}`
export const createRole = () => `${roleUrl}`
export const getRole = (id) => `${roleUrl}/${id}`
export const deleteRole = (id) => `${roleUrl}/${id}`
export const updateRole = (id) => `/app/account/${id}/role`
export const userListByRoleId = (roleId) => `/app/account/user-list-by-role-id/${roleId}`
export const treeGrant = () => `/app/account/permission`
export const updateGrant = () => `/app/account/permission`

export const menuUrl = '/app/menu'
export const getAllRoleMenu = (roleName) => `${menuUrl}/role-menu?roleName=${roleName}`
export const updateAllRoleMenu = (roleName) => `${menuUrl}/all-role-menu?roleName=${roleName}`